
/************************** Cart Action ***************************/

import { Action } from "@ngrx/store";
import { FavouritesInterface, OrdersInterface, points_interface, UserAddressInterface, wallet_interface } from "src/app/Services/ProfileService/profile.interface";
import * as types from './constants/constants';




export class GET_USER_FAVOURITES_ACTION implements Action
{

   readonly type: string = types.GET_USER_FAVOURITE;
   constructor( public data: number ){}

}


export class SET_USER_FAVOURITES_ACTION implements Action
{

   readonly type: string = types.SET_USER_FAVOURITES;
   constructor( public data: FavouritesInterface[] ){}

}


export class GET_USER_ORDERS_ACTION implements Action
{

   readonly type: string = types.GET_USER_ORDERS;
   constructor( public data: number ){}

}


export class SET_USER_ORDERS_ACTION implements Action
{

   readonly type: string = types.SET_USER_ORDERS;
   constructor( public data: OrdersInterface[] ){}

}



export class REQUEST_USER_ADDRESSES_ACTION implements Action
{

   readonly type: string = types.REQUEST_USER_ADDRESSES;
   constructor(){}

}


export class SET_USER_ADDRESSES_ACTION implements Action
{

   readonly type: string = types.SET_USER_ADDRESSES;
   constructor( public data: UserAddressInterface[] ){}

}


export class SET_ACTIVE_USER_ADDRESS_ACTION implements Action
{

   readonly type: string = types.SET_ACTIVE_USER_ADDRESS;
   constructor( public data: UserAddressInterface ){}

}

export class UPDATE_RATE_MODAL_DISPLAY_STATUS_ACTION implements Action
{

   readonly type: string = types.UPDATE_RATE_MODAL_DISPLAY_STATUS;
   constructor( public data: boolean ){}

}

export class GET_USER_POINTS_ACTION implements Action
{

   readonly type: string = types.GET_USER_POINTS;
   constructor(){}

}


export class SET_USER_POINTS_ACTION implements Action
{

   readonly type: string = types.SET_USER_POINTS;
   constructor(public data: points_interface){}

}







export type ActionsUnion = GET_USER_FAVOURITES_ACTION & SET_USER_POINTS_ACTION;
